/** @format */

let appConfig = process.env.REACT_APP_CONFIG || {};

if (typeof JSON.parse(JSON.stringify(appConfig)) === 'string') {
  appConfig = JSON.parse(appConfig);
} else {
  appConfig = JSON.parse(JSON.stringify(appConfig));
}

const { ENVIRONMENT } = appConfig;

const sessionEndTime = new Date().getTime() + 1000 * 60 * 48; // 48 minutes

const config = {
  ENVIRONMENT,
  defaultPathName: '/',
  mobileScreenMaxWidth: 919,
  sessionEndTime: sessionEndTime,
  defaultDateValue: '1900-01-01',
  /** Date format to display on date elements */
  defaultMomentDateFormat: 'DD/MM/YYYY',
  defaultMomentDateTimeFormat: 'DD/MM/YYYY hh:mm:ss',
  /** new broker users password minimum length */
  brokerNewPasswordMinimumLength: 8,
  /** New broker user temporary password validator regex
   * Should have lowercase characters, uppercase characters, special character and numbers
   */
  brokerNewPasswordValidatorRegex:
    '(?=^.{6,}$)(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^A-Za-z0-9]).*',

  emailValidatorRegex: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$',
  /**
   * Base url for Fria maklare APi server
   */
  baseApiUrl: process.env.REACT_APP_API_GATEWAY_URL,
  onBoardingOriginUrl: `${process.env.REACT_APP_WEB_APP_URL}/registrera/valkommen`,
  brokerPanelUrl: `${process.env.REACT_APP_WEB_APP_URL}/profil`,
  baseUrl: `${process.env.REACT_APP_WEB_APP_URL}`
};

export default config;
